import { closest, removeNode } from '@utils/domUtils';
import { post } from '@utils/request';

/* global ACTION_ROUTES */

export default class ApplicationNoteList {
  static selectorString() {
    return '.ApplicationNoteList';
  }

  render(node, props) {
    this.isDeleting = false;

    [...this.node.querySelectorAll('[data-action="deleteNote"]')].forEach(element => {
      element.note = closest(element, '.application-note');
      element.note.noteId = element.note.getAttribute('data-id');
      element.note.applicationId = parseInt(element.note.getAttribute('data-application-id'));
      element.addEventListener('click', this.deleteNote.bind(this));
    });
  }

  deleteNote(event) {
    if (this.isDeleting) {
      return;
    }

    const note = event.currentTarget.note;

    if (note) {
      this.isDeleting = true;

      post({
        url: ACTION_ROUTES.DELETE_NOTE,
        data: {
          applicationId: note.applicationId,
          noteId: note.noteId,
        },
        success: data => {
          this.isDeleting = false;
          removeNode(note);
        },
        error: () => {
          this.isDeleting = false;
        },
      });
    }
  }
}
